package fr.frux.core.ads.di

import dev.zacsweers.metro.ContributesTo
import dev.zacsweers.metro.Provides
import dev.zacsweers.metro.SingleIn
import fr.frux.core.ads.AdSessionTracker
import fr.frux.core.ads.AdsController
import fr.frux.core.ads.DefaultAdsController
import fr.frux.core.ads.adsConfig
import fr.frux.core.ads.createAdsPlatform
import fr.frux.core.common.di.AppScope
import fr.frux.core.common.entitlements.EntitlementsHolder
import fr.frux.core.common.entitlements.EntitlementsRefresher
import fr.frux.core.common.prefs.AppPreferences
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob
import kotlin.time.Clock

/**
 * Module Metro du contrôleur publicitaire (#527), sur le modèle de `PushRegistrarModule`. Agrégé
 * dans le graphe par `:shared`, qui fournit aussi [EntitlementsRefresher] (relecture de `/auth/me`).
 *
 * Portée de l'application et thread principal : le contrôleur suit le premier plan du process et
 * les droits du compte pendant toute la vie de l'app, et ses appelants sont des écrans.
 */
@ContributesTo(AppScope::class)
interface AdsModule {
    companion object {
        @Provides
        @SingleIn(AppScope::class)
        fun provideAdsController(
            entitlements: EntitlementsHolder,
            refresher: EntitlementsRefresher,
            prefs: AppPreferences,
        ): AdsController =
            DefaultAdsController(
                platform = createAdsPlatform(),
                entitlements = entitlements,
                refresher = refresher,
                sessions = AdSessionTracker(prefs, Clock.System),
                config = adsConfig(),
                scope = CoroutineScope(SupervisorJob() + Dispatchers.Main),
            )
    }
}
